"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var brandCenter;
        (function (brandCenter) {
            var settings;
            (function (settings) {
                let _currentIconSet = appn.emptyString;
                function init() {
                    appn.filesUploading = 0;
                    addEvents();
                    _currentIconSet = String($('#AaaSDetails_IconSet').val());
                    appn.icons.init();
                }
                settings.init = init;
                function addEvents() {
                    $('#AaaSDetails_IconSet').change(function () {
                        const newIconSet = $(this).val();
                        let iconcount = 0;
                        $('.fileinput-new.thumbnail img').each(function () {
                            const currentImageSrc = $(this).attr('src');
                            const imglazy = $(this).data('imglazyurl');
                            if (currentImageSrc && currentImageSrc.indexOf('Files/') === -1)
                                $(this).attr('src', currentImageSrc === null || currentImageSrc === void 0 ? void 0 : currentImageSrc.replace(_currentIconSet, newIconSet));
                            if (imglazy && imglazy.indexOf('Files/') === -1)
                                $(this).attr('data-imglazyurl', imglazy.replace(_currentIconSet, newIconSet));
                        });
                        _currentIconSet = newIconSet;
                    });
                    $('.iconUpload').fileupload({
                        dataType: 'json',
                        change: function (event, data) {
                            const file = data.files[0];
                            const isValidExt = appn.utils.isValidFileExtension(['.png'], file.name);
                            const isValidSize = appn.utils.IsValidFileSize(50, file);
                            if (!isValidExt || !isValidSize) {
                                const that = this;
                                setTimeout(function () {
                                    $(that).closest('.fileinput').find('.btn.fileinput-exists.btn-remove').click();
                                }, 500);
                            }
                            return isValidExt && isValidSize;
                        },
                        submit: function (event, data) {
                            data.formData = {
                                iconname: $(this).closest('.iconInfo').data('icon'),
                                brandid: $('#Brand_Id').val(),
                                icontype: $(this).closest('.iconInfo').data('icontype')
                            };
                        },
                        send: function (event, data) {
                            appn.filesUploading++;
                        },
                        always: function (event, data) {
                            appn.filesUploading--;
                        },
                        done: function (event, data) {
                            if (data.result.error) {
                                appn.fileUploadUtils.fileUploadFailed(data.result.error);
                                return;
                            }
                            $(this).closest('.iconInfo').find('input.iconPath').val(data.result);
                        },
                        error: function (response) {
                            appn.fileUploadUtils.fileUploadFailed();
                        },
                        fail: function (event, data) {
                            appn.fileUploadUtils.fileUploadFailed();
                        }
                    });
                    $('.iconReset').on('click', function (event) {
                        event.preventDefault();
                        const iconPath = $(this).closest('.iconInfo').find('input.iconPath');
                        const setName = _currentIconSet;
                        let setPath = String(iconPath.val()).replace(`Files/Brand/${$('#Brand_Id').val()}`, setName);
                        if (setPath.contains('sys_'))
                            setPath = setPath.replace('sys_', appn.emptyString);
                        iconPath.val(setPath);
                        $(this).closest('.fileinput').find('.thumbnail')
                            .find('img').attr('src', `${appn.urls.root}Content/icons/${setPath}`);
                        $(this).hide();
                    });
                }
            })(settings = brandCenter.settings || (brandCenter.settings = {}));
        })(brandCenter = views.brandCenter || (views.brandCenter = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
